import { ApiEndpoint } from "utils/baseFetcher";

export const getCountriesUrl = () => {
  const url = new ApiEndpoint("/api/v2/countries");
  return url.href;
};

export const getGeographiesUrl = () => {
  const url = new ApiEndpoint("/api/v2/geographies");
  url.searchParams.append("include", "countries");
  return url.href;
};

export const getSectorsUrl = () => {
  const url = new ApiEndpoint("/api/v2/sectors");
  url.searchParams.append("include", "industry-groups");
  return url.href;
};

export const getContentVertivalsUrl = () => {
  const url = new ApiEndpoint("/api/v2/content-verticals");
  return url.href;
};

export const getMutedItemsUrl = (type: string) => {
  const url = new ApiEndpoint("/api/v2/muted-items");

  url.searchParams.append("filter[mutable-type]", type);
  url.searchParams.append("include", `muted-${type}`);
  url.searchParams.append("page[number]", "1");
  url.searchParams.append("page[size]", "12");

  return url.href;
};

export const getSubscribedVerticalsUrl = (id: string) => {
  const url = new ApiEndpoint(`/api/v2/accounts/${id}/subscribed-verticals`);

  return url.href;
};

export const MARKET_CAPS = [
  {
    id: "1",
    value: "any",
    text: "Any",
    min: null,
    max: null,
  },
  {
    id: "2",
    value: "small-mid-cap",
    text: "Small & Mid Cap",
    min: null,
    max: 5000,
  },
  {
    id: "3",
    value: "large-cap",
    text: "Large Cap",
    min: 5000,
    max: null,
  },
];
